import React, { useContext } from "react"
import Context from "../utils/Context"
import api from "../api/api"
import { cancelActions, releaseLifter } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan, faCog, faExclamationCircle, faCloudDownloadAlt, faWindowClose } from '@fortawesome/free-solid-svg-icons'

export default function ListOrders(props) {

    const context = useContext(Context)

    const cancelOrder = (id,inProgress) => {

        api.cancelOrders(id)
            .then((res) => {
                props.cancelled(!props.cancelledValue)
                console.log("RES", res)
            })
            .catch((e) => console.log(e))

        if(inProgress){
            
            cancelActions({ stopAll: true })
            //releaseLifter({ data: 64 })
        }

    }

    const verifyStatus = (order) => {

        let stateOrder
        if (order?.dtStarted) {
            stateOrder = "Executing"
        } else if (order?.dtReceived) {
            stateOrder = "In Queue"
        } else {
            stateOrder = "Wait"
        }

        return stateOrder

    }

    //const orders = props.data.sort((a, b) => b.value - a.value).slice(0, 5)
    const orders = props.data
    .sort((a, b) => a.executionQueue - b.executionQueue) // sort by executionQueue 
    .slice(0, 7);

    return (
        <>
            <div className="table-container orders-list-table">
                <table className="table is-hoverable is-fullwidth is-size-7">
                    <thead>
                        <tr>
                            {props.headers.map((header, index) => (
                                <th className={`is-capitalized `} key={index}>
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {orders.map((order, index) => {

                            const dateStart =
                                order.dtStarted &&
                                context.monthNames[new Date(order.dtStarted).getMonth()] +
                                " " +
                                new Date(order.dtStarted).getDate()

                            const timeStart =
                                order.dtStarted && order.dtStarted.split("T")[1].substr(0, 5)

                            return (
                                <tr
                                    key={index}
                                    className="table-row"
                                    onClick={(event) => props.handler(order._id)}
                                >
                                    <td>
                                        <span>{order.missionName}</span>
                                    </td>
                                    <td>
                                        <span>{order.robotName}</span>
                                    </td>
                                    <td>
                                        {order.dtStarted ? (
                                            <span>
                                                {dateStart} {timeStart}
                                            </span>
                                        ) : (<span>-</span>)}
                                    </td>
                                    <td>
                                        <span className=" mr-2 ">
                                            {() => verifyStatus(order)}
                                        </span>
                                    </td>
                                    <td>
                                    <span className="icon">
                                            {order.dtStarted ? (
                                                <button key={index} className="button is-danger is-light mr-3" disabled={context.currentTask === 'release-charger'} onClick={() => cancelOrder(order._id, true)}  >
                                                    <FontAwesomeIcon icon={faCog} className="fas fa-lg fa-pulse mr-2 ml-2" />
                                                </button>
                                            ) : order.dtReceived ? (
                                                <button key={index} className="button is-danger is-light mr-3" onClick={() => cancelOrder(order._id, false)}>
                                                    <FontAwesomeIcon icon={faBan} className="fas fa-lg  mr-2 ml-2" />
                                                    
                                                </button>
                                            ) : (
                                                <button key={index} className="button is-info is-light mr-3" onClick={() => cancelOrder(order._id, false)}>
                                                    <FontAwesomeIcon icon={faBan} className="fas fa-lg  mr-2 ml-2"  />
                                                </button>
                                            )}
                                       </span>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                {(!props.data || (props.data && props.data.length <= 0)) &&
                    <div>
                        <span className="icon is-small">

                            <FontAwesomeIcon icon={faExclamationCircle} className="is-small mr-1" />
                        </span>

                        <span>No orders!</span>
                    </div>
                }
            </div>
        </>
    )
}
